import axios from "../../config/axiosConfig";
import { SALES_RETURN_REGISTER_REPORT_FAILURE, SALES_RETURN_REGISTER_REPORT_REQUEST, SALES_RETURN_REGISTER_REPORT_SUCCESS } from "../types";

export const getSalesReturnRegisterReport = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SALES_RETURN_REGISTER_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };
      // console.log('params.book_ids',params);
      console.log('params.fromDate',params.fromDate);
      console.log('params.toDate',params.toDate);
      
      const defaultParams2 = {
        book_ids: params.book_ids,
        filterType: params.filterType, 
        selectedBills: params.selectedBills, 
        selectedParties: params.selectedParties, 
        fromDate: params.fromDate, 
        toDate: params.toDate,
        ...params 
      };
      // Merge default params with provided params
      const requestParams = { ...defaultParams, ...defaultParams2 };

      // If 'selectedBook' exists and is an array, convert it to a comma-separated string
      // if (Array.isArray(requestParams.selectedBook)) {
      //   requestParams.selectedBook = requestParams.selectedBook.join(',');
      // }

      // Log the request parameters
      // console.log('Request Param Datas >>>>>>>>>>>>>>>>>>>>>>>>', requestParams);

      // Construct the complete URL with query parameters
      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/sales-return/getSalesReturnReport?${queryString}`;

      // Log the full URL (to debug)
      console.log('Complete API Request URL: ', fullUrl);

      // Make API call
      return axios.get(fullUrl).then((response) => {
        console.log('API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: SALES_RETURN_REGISTER_REPORT_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching Sales Return Register Report:", error);
        dispatch({ type: SALES_RETURN_REGISTER_REPORT_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error("Error fetching Sales Return Register Report:", error);
      dispatch({ type: SALES_RETURN_REGISTER_REPORT_FAILURE, error: error.message });
    }
  };
};

export const clearSalesReturnRegisterReport = () => {
  return async (dispatch) => {
    dispatch({ type: SALES_RETURN_REGISTER_REPORT_SUCCESS, payload: {} });
  }
}